module.exports = __webpack_public_path__ + "static/media/instagram.e7c63b70.svg";